var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoDark = function SvgLogoDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66.47 49.21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#34394d;}.cls-2{fill:#ef7f24;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.19,16.82h5.22V41.55H38.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.32,24.66a10.62,10.62,0,0,1-2.56-.31v16c0,3.94-.52,5-2.34,5a4.53,4.53,0,0,1-2.34-.56L0,48.58a15.52,15.52,0,0,0,4.39.63c3,0,5.09-1.26,6-3.6.59-1.53.78-3.31.78-7V24.29A10.52,10.52,0,0,1,8.32,24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.38,15.58A4.12,4.12,0,0,1,8.3,19.69a4.09,4.09,0,1,1,4.08-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.61,23.8A9.17,9.17,0,1,0,33.78,33,9.16,9.16,0,0,0,24.61,23.8Zm0,13.25A4.08,4.08,0,1,1,28.69,33,4.12,4.12,0,0,1,24.61,37.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.27,24.36v1.82h-.06a5.81,5.81,0,0,0-5-2.41c-4.91,0-8.59,4.08-8.59,9.14s3.52,9.17,8.59,9.17c2.25,0,4.29-.92,5-2.44h.06V41.5H66.4V24.36ZM57,37a4.08,4.08,0,1,1,4.08-4.1A4.13,4.13,0,0,1,57,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.16.11H6A3,3,0,0,1,7,.28a1.72,1.72,0,0,1,.8.6A1.66,1.66,0,0,1,8.13,2a1.78,1.78,0,0,1-.2.85,1.45,1.45,0,0,1-.51.58,2.39,2.39,0,0,1-.69.31A2.74,2.74,0,0,1,6,3.8H4.82V6.39H4.16Zm.66.61V3.19h.93c1.11,0,1.67-.41,1.67-1.22A1.14,1.14,0,0,0,7,1.05,1.66,1.66,0,0,0,5.93.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.34,1a3.16,3.16,0,0,1,.93,2.3,3.16,3.16,0,0,1-.93,2.3,3.21,3.21,0,0,1-4.56,0,3.19,3.19,0,0,1-.92-2.3A3.19,3.19,0,0,1,10.78,1a3.21,3.21,0,0,1,4.56,0Zm-.5,4.17a2.6,2.6,0,0,0,.72-1.87,2.65,2.65,0,0,0-.72-1.88,2.46,2.46,0,0,0-3.56,0,2.64,2.64,0,0,0-.71,1.88,2.6,2.6,0,0,0,.71,1.87,2.44,2.44,0,0,0,3.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,.11l1.34,5.13h0L24.84.11h.65l-1.8,6.28H23L21.7,1.22h0L20.26,6.39H19.6L17.88.11h.69L20,5.24h0L21.4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.1,6.39H27.45V.11H31.1V.72h-3V2.84h3v.61h-3V5.78h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.21,3.65V6.39h-.66V.11h1.8a2.57,2.57,0,0,1,.73.1,2.17,2.17,0,0,1,.66.3,1.5,1.5,0,0,1,.51.55,1.8,1.8,0,0,1,.19.82A1.64,1.64,0,0,1,37,3a2,2,0,0,1-1.2.59q.8,1.1,2,2.76H37L35,3.65Zm0-2.93V3h.92c1.06,0,1.6-.38,1.6-1.15A1.06,1.06,0,0,0,36.34,1a1.6,1.6,0,0,0-1-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.52,6.39H39.87V.11h3.65V.72h-3V2.84h3v.61h-3V5.78h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,6.39V.11H47.6a4.34,4.34,0,0,1,1,.1,3.4,3.4,0,0,1,.9.34,3,3,0,0,1,.76.59,2.49,2.49,0,0,1,.52.89,3.5,3.5,0,0,1,.2,1.19,3.54,3.54,0,0,1-.29,1.47,2.47,2.47,0,0,1-.8,1,3.58,3.58,0,0,1-1.09.54,4.6,4.6,0,0,1-1.25.17Zm.66-.61H47a4.26,4.26,0,0,0,2.4-.57,2.14,2.14,0,0,0,.83-1.91,2.46,2.46,0,0,0-.73-1.92A3,3,0,0,0,47.43.72h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.49.11h1.44a2.89,2.89,0,0,1,1.66.42,1.42,1.42,0,0,1,.61,1.24,1.35,1.35,0,0,1-1,1.36,1.45,1.45,0,0,1,1.26,1.51,1.5,1.5,0,0,1-1,1.49,4.08,4.08,0,0,1-1.59.26H56.49Zm.66.61V2.87h.72c1.11,0,1.67-.35,1.67-1.06a.9.9,0,0,0-.4-.83A2.88,2.88,0,0,0,57.66.72Zm0,5.06h.56a3.88,3.88,0,0,0,1.46-.2.94.94,0,0,0,.57-.94,1,1,0,0,0-.38-.84,1.63,1.63,0,0,0-1.07-.32H57.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.47.11l-2,3.6V6.39h-.67V3.58L61.85.11h.82l1.49,2.81h0L65.7.11Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_dark.c3d8208c.svg";
export { ForwardRef as ReactComponent };